import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { SkeletonCommonModule } from '../../common/components/common.module';

@NgModule({
  declarations: [TableComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [TableComponent]
})
export class TableModule {}
